module.exports = __webpack_public_path__ + "static/GreycliffCF-Regular-bf09891def2461044cf24f1940d9fc0e.ttf";